import { ContentItem } from '@smart-tv/typings/content';

type SetContentAction = {
  type: 'SET_CONTENT';
  payload: ContentItem[];
};

type RemoveContentAction = {
  type: 'REMOVE_CONTENT';
  payload: number;
};

type ToggleFavoritedContentAction = {
  type: 'TOGGLE_FAVORITED_CONTENT';
  payload: number;
};

type ActionableContentActions =
  | SetContentAction
  | RemoveContentAction
  | ToggleFavoritedContentAction;

const actionableContentContextReducer = (
  state: ContentItem[] | undefined,
  action: ActionableContentActions
) => {
  switch (action.type) {
    case 'SET_CONTENT':
      return action.payload;

    case 'REMOVE_CONTENT':
      return (
        state &&
        state &&
        state.filter((actionableItem) => actionableItem.contentId !== action.payload)
      );

    case 'TOGGLE_FAVORITED_CONTENT':
      return (
        state &&
        state.map((actionableItem) =>
          actionableItem.contentId === action.payload
            ? { ...actionableItem, favorited: !actionableItem.favorited }
            : actionableItem
        )
      );
  }
};

export default actionableContentContextReducer;
